import { translateResourceString } from '../../../util/translationUtility';

const partnerIdValidator = {
    key: "PartnerIds",
    validate: (value, orderDetails) => {
        return (orderDetails.IsPartnerIdRequired && (!value || value.length < orderDetails.RequiredPartnerIds)) && translateResourceString("/Checkout/PlaceOrder/Errors/PartnerIdIsRequired");
    }
  }

 const termsAndConditionsValidator = {
    key: "TermsAndConditions",
    validate: (value, orderDetails) => {
        return (orderDetails.IsTermsAndConditionsRequired && !value) && translateResourceString("/Checkout/PlaceOrder/Errors/TermsAndConditions");
    }
  }

const selectedShippingAddressValidator = {
    key: "SelectedShippingAddress",
    validate: (value, orderDetails) => {        
        return ((orderDetails.IsShippingRequired || orderDetails.billingEqualsShipping) && (!value || !value.Id)) && translateResourceString("/Checkout/PlaceOrder/Errors/ShippingAddressNotSelected");
    }
}
const selectedStopworkShopValidator = {
    key: "SelectedProduct",
    validate: (value, orderDetails) => {
        if (value === false) {
            return; // or return null if you prefer
        }
        return ((orderDetails.IsStopWorkshop)) && translateResourceString("/Checkout/PlaceOrder/Errors/IsStopWorkShop");
    }
}

  const internationalShippingAddressValidator = {
    key: "SelectedShippingAddress",
    validate: (value, orderDetails) => {
        return (orderDetails.IsShippingRequired && (value && value.Id && (value.CountryCode !== 'USA' && value.CountryCode !== 'CAN'))) && translateResourceString("/Checkout/PlaceOrder/Errors/InternationalShippingAddressSelected");
    }
  }
  
 const selectedBillingAddressValidator = {
    key: "SelectedBillingAddress",
    validate: (value, orderDetails) => {
        return SelectedBillingAddressCanBeSubmitted(value, orderDetails["BillingEqualsShipping"]);
    }
  }
  
 const selectedShippingOptionValidator = {
    key: "SelectedShippingOption",
     validate: (value, orderDetails) => {
         if (value === true) {
             return; // or return null if you prefer
         }
        return (orderDetails.IsShippingRequired && (!value || !value.Id)) && translateResourceString("/Checkout/PlaceOrder/Errors/ShippingOptionNotSelected");
    }
  }
 
 const selectedPaymentValidator = {
    key: "SelectedPayment",
    validate: (value, orderDetails) => {
        return paymentIsInvalid(orderDetails.constants, value);
    }
  }
      
 const totalValidator = {
    key: "Total",
    validate: (value) => {
        return (typeof value !== 'number') || value < 0  && translateResourceString("/Checkout/PlaceOrder/Errors/Total"); 
    }
  }

const addressIsMissingIdOrRequiredData = function (address) {
    return (
        !address
        || !address.Id // True if address.Id is falsy
        || !(          // True if any fields are falsy
            !!address.Name &&
            !!address.AddressLine1 &&
            !!address.City &&
            !!address.CountryCode &&
            !!address.PostalCode))
    };
  
const SelectedBillingAddressCanBeSubmitted = (address, billingEqualsShipping) => {
    return (
        (!billingEqualsShipping && addressIsMissingIdOrRequiredData(address))
        && translateResourceString("/Checkout/PlaceOrder/Errors/InvalidBillingAddress")
    )
  }
  
const paymentIsInvalid = (constants, { Id, POValue, BraintreePaymentNonce }) => {
    if (!Id) {
        return translateResourceString("/Checkout/PlaceOrder/Errors/NoPaymentSelect");
    } else if (Id === constants.braintreeSettings.braintreePaymentId && !BraintreePaymentNonce) {
        return translateResourceString("/Checkout/PlaceOrder/Errors/PaymentInvalid");
    }
    return false;
  }

  export const orderCanContinueValidators = [
    selectedShippingAddressValidator,
    internationalShippingAddressValidator,
    selectedBillingAddressValidator,
      selectedShippingOptionValidator,

   
    totalValidator,
    partnerIdValidator,
      termsAndConditionsValidator,
      selectedStopworkShopValidator,
  ];

 export const orderCanBeSubmittedValidators = [
    selectedShippingAddressValidator,
    internationalShippingAddressValidator,
    selectedBillingAddressValidator,
    selectedShippingOptionValidator,
    selectedPaymentValidator,
    totalValidator,
    partnerIdValidator,
     termsAndConditionsValidator,
     selectedStopworkShopValidator,

];
